var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"my-2 d-flex justify-center align-center"},[_c('v-col',{staticClass:" d-flex justify-center align-center",attrs:{"cols":"10"}},[_c('v-divider')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }